var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { NaviError, Status, SegmentType } from 'navi';
import { NavContext } from './NavContext';
export var NavContent = function NavContent(props) {
  return React.createElement(NavContext.Consumer, null, function (context) {
    return React.createElement(InnerNavContent, __assign({}, props, {
      context: context
    }));
  });
};
NavContent.defaultProps = {
  where: function where(segment) {
    return segment.content || segment.type !== SegmentType.Switch;
  }
};

var InnerNavContent =
/** @class */
function (_super) {
  __extends(InnerNavContent, _super);

  function InnerNavContent(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {};
    return _this;
  }

  InnerNavContent.getDerivedStateFromProps = function (props, state) {
    // If there's no steady route, then we'll need to wait until a steady
    // route becomes available.
    if (!props.context.steadyRoute) {
      return null;
    } // Bail if nothing has changed


    if (state.steadyRoute === props.context.steadyRoute && state.childContext && state.childContext.busyRoute === props.context.busyRoute) {
      return null;
    }

    var unconsumedSegments = props.context.unconsumedSteadyRouteSegments || props.context.steadyRoute.segments;
    var index = props.where ? unconsumedSegments.findIndex(props.where) : 0;
    var errorSearchSegments = index === -1 ? unconsumedSegments : unconsumedSegments.slice(0, index + 1);
    var errorSegment = errorSearchSegments.find(function (segment) {
      return segment.status === Status.Error;
    });

    if (errorSegment) {
      return {
        error: errorSegment.error || new Error("Unknown routing error")
      };
    }

    if (index === -1) {
      return {
        error: new MissingSegment(props.context)
      };
    }

    var consumedSegments = unconsumedSegments.slice(0, index + 1);
    var segment = unconsumedSegments[index];
    return {
      segment: segment,
      consumedSegments: consumedSegments,
      steadyRoute: props.context.steadyRoute,
      childContext: __assign({}, props.context, {
        busyRoute: props.context.busyRoute,
        unconsumedSteadyRouteSegments: unconsumedSegments.slice(index + 1)
      })
    };
  };

  InnerNavContent.prototype.componentDidUpdate = function (prevProps, prevState) {
    this.handleUpdate(prevState);
  };

  InnerNavContent.prototype.componentDidMount = function () {
    this.handleUpdate();
  };

  InnerNavContent.prototype.handleUpdate = function (prevState) {
    if (this.state.steadyRoute && (!prevState || !prevState.steadyRoute || prevState.steadyRoute !== this.state.steadyRoute)) {
      if (this.props.context.onRendered) {
        this.props.context.onRendered();
      }
    }
  };

  InnerNavContent.prototype.render = function () {
    if (this.state.error) {
      throw this.state.error;
    }

    var segment = this.state.segment;

    if (!segment) {
      var Suspense = React.Suspense;

      if (Suspense) {
        throw this.props.context.navigation.steady();
      } else {
        console.warn("A <NavContent> component was rendered before your Navigation store's state had become steady. Consider waiting before rendering with \"await navigation.steady()\", or upgrading React to version 16.6 to handle this with Suspense.");
        return null;
      }
    }

    var content;
    var render;

    if (this.props.children) {
      render = this.props.children;

      if (typeof render !== "function") {
        throw new Error("<NavContent> expects its children to be a function, but instead received \"" + render + "\".");
      }
    } else if (segment && segment.content) {
      if (typeof segment.content === 'function') {
        if (segment.content.prototype instanceof React.Component) {
          content = React.createElement(segment.content, {
            segment: segment,
            route: this.props.context.steadyRoute
          });
        } else {
          render = segment.content;
        }
      } else if (React.isValidElement(segment.content)) {
        content = segment.content;
      }
    }

    if (render) {
      content = render(segment.content, segment, this.props.context.steadyRoute);
    }

    if (content === undefined) {
      throw new Error("<NavContent> was not able to find a `children` prop, or a `render` function in the consumed RouteSegment's `content`.");
    }

    return React.createElement(NavContext.Provider, {
      value: this.state.childContext
    }, // Clone the content to force a re-render even if content hasn't
    // changed, as Provider is a PureComponent.
    React.isValidElement(content) ? React.cloneElement(content) : content);
  };

  return InnerNavContent;
}(React.Component);

var MissingSegment =
/** @class */
function (_super) {
  __extends(MissingSegment, _super);

  function MissingSegment(context) {
    var _this = _super.call(this, "A <NavContent> component attempted to use a segment that couldn't be found. This is likely due to its \"where\" prop.") || this;

    _this.context = context;
    return _this;
  }

  return MissingSegment;
}(NaviError);

export { MissingSegment };